module.exports = __webpack_public_path__ + "static/media/Introducingtlyfe.9c008f53.png";